import { ActionTypes } from '../constants/actionTypes.js';

export const setSelectedDateRange = (daterange) => ({
    type: ActionTypes.SET_SELECTED_DATERANGE,
    payload: daterange
   });
  